<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'活动沙龙报名审核'}]" :title="'活动沙龙报名审核'"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="待审核" name="1" v-if="authorities.indexOf('sys:permission:background:salon:apply:unAudit')!==-1"></el-tab-pane>
              <el-tab-pane label="审核记录" name="2" v-if="authorities.indexOf('sys:permission:background:salon:apply:audit')!==-1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">审核结果</span>
                        <el-select v-model="sendInfo.checkStatus" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="sendInfoOne.time"
                            format="yyyy-MM-dd"
                        	value-format="yyyy-MM-dd HH:mm:ss"
                        	type="datetimerange" 
                        	:default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                v-show="tab==='1'"
                :data="tableData"
                :default-sort="{prop: 'date'}"
                @sort-change="sortChange"
                ref="table"
                    fit
                    :height="bHeight"
                    :header-cell-style="headerStyle"
                    v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="活动标题">
                    <template slot-scope="scope">
                        <div class="tableName ellipsis" @click="viewDetails(scope.row)">{{scope.row.activityTitle}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
					v-if="authorities.indexOf('sys:permission:background:salon:apply:unAudit:button:view')!=-1||authorities.indexOf('sys:permission:background:salon:apply:unAudit:button:audit')!=-1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain 
						 v-if="authorities.indexOf('sys:permission:background:salon:apply:unAudit:button:view')!=-1"
						@click="check(scope.row)">查看</el-button>
                        <el-button size="small" type="primary" class="super" plain 
						 v-if="authorities.indexOf('sys:permission:background:salon:apply:unAudit:button:audit')!=-1"
						@click="audit(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
               :default-sort="{prop: 'date'}"
               @sort-change="sortChange"
                ref="multipleTable"
                    fit
                    :height="bHeight"
                    :header-cell-style="headerStyle"
                    v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    
                    width="200"
                    label="活动标题">
                    <template slot-scope="scope">
                        <div class="tableName ellipsis" @click="viewDetails(scope.row)">{{scope.row.activityTitle}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    
                    width="100"
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    
                    width="200"
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    label="审核账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    sortable
                    width="150"
                    label="审核时间">
                </el-table-column>
                <el-table-column
                    prop="checkStatusValue"
                    show-overflow-tooltip
                    
                    width="150"
                    label="审核结果">
                </el-table-column>
                <el-table-column
				    v-if="authorities.indexOf('sys:permission:background:salon:apply:audit:button:view')!=-1"
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
            	<Paging
            	:PageData="PageData"
            	v-if="tableData.length>0"
            	@nextpage="nextpage"
            	@previouspage="previouspage"
            	@handleSizeChange="handleSizeChange"
            	@handleCurrentChange="handleCurrentChange"
            	></Paging>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看表格详情 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogDetail"
                width="50%">
                <div class="basic">
                    <div class="child">
                        <div class="name">活动标题：</div>
                        <div class="content">{{dataInfo.activityTitle||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">活动类型：</div>
                        <div class="content">{{dataInfo.activityTypeValue||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">报名截止时间：</div>
                        <div class="content">{{dataInfo.registrationDeadline||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">活动开始时间：</div>
                        <div class="content">{{dataInfo.startDate||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">活动结束时间：</div>
                        <div class="content">{{dataInfo.endDate||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">活动举办地址：</div>
                        <div class="content">{{dataInfo.activityAddress||'--'}}</div>
                    </div>
                    <div class="child">
                        <div class="name">活动主办单位：</div>
                        <div class="content">{{dataInfo.activityOrganizer||'--'}}</div>
                    </div>
                    <div class="child" v-if="dataInfo.fitCrowd&&dataInfo.fitCrowd.length>0">
                        <div class="name">适用人群：</div>
                        <div class="content">
                    	<span v-for="(i,index) in dataInfo.fitCrowd" :key="index">
                    		{{i.value||'--'}}
                    	</span>
                    	</div>
                    </div>
                    <div class="child">
                        <div class="name">来源：</div>
                        <div class="content">{{dataInfo.source||'--'}}</div>
                    </div>
                    <div class="richText">
                        <div class="name">活动详情：</div>
                        <div class="content" v-html="dataInfo.activityDetails">{{dataInfo.activityDetails||'--'}}</div>
                    </div>
                    <div class="attachment"  v-if="dataInfo.fileList&&dataInfo.fileList.length>0">
                        <div class="name">附件：</div>
                        <ul class="content">
                    		<li v-for="(i,index) in dataInfo.fileList" :key="index">
                    			<span>{{i.fileName}}</span>
                    			<i class="el-icon-download" @click="downLoad(dataInfo.frontPath+i.filePath)"></i>
                    		</li>
                        </ul>
                    </div>
                </div>
            </el-dialog>
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                width="50%">
                <div class="basic">
                    <div class="boxChild">
                        <div class="basisTitle">账号信息</div>
                        <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{dataInfos.createUserName||'--'}}</div>
                        </div>
                        <div class="child" v-if="dataInfos.user">
                            <div class="name">账号类型：</div>
                            <div class="content">{{dataInfos.user.userTypeName||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{dataInfos.createName||'--'}}</div>
                        </div>
                        <div class="child" v-if="dataInfos.user">
                            <div class="name">邮箱：</div>
                            <div class="content">{{dataInfos.user.email||'--'}}</div>
                        </div>
                        <div class="child" v-if="dataInfos.user">
                            <div class="name">联系地址：</div>
                            <div class="content">{{dataInfos.user.contactAddress||'--'}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">提交信息</div>
                        <div class="child">
                            <div class="name">申请人姓名：</div>
                            <div class="content">{{dataInfos.applicant||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{dataInfos.contactPhone||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司全称：</div>
                            <div class="content">{{dataInfos.applyCompany||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
							<div class="content">{{dataInfos.applyRemark||'--'}}</div>
                        </div>
                        <div class="attachment" v-if="dataInfos.fileList">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,index) in dataInfos.fileList" :key="index">
									<span>{{item.fileName}}</span>
									<i class="el-icon-download" @click="downLoad(item.frontPath+item.filePath)"></i>
								</li>
                            </ul>
                        </div>
                        <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{dataInfos.createTime||'--'}}</div>
                        </div>
                    </div>
                    <div class="boxChild" v-if="tab==='2'">
                        <div class="basisTitle">审核结果</div>
                        <div class="child">
                            <div class="name">审核结果：</div>
                            <div class="content">{{dataInfos.checkStatusValue||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{dataInfos.modifyUserName||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{dataInfos.updateTime||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
							<div class="content">{{dataInfos.checkExplanation||'--'}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
           <!-- 审核 -->
           <el-dialog
               title="审核"
               :visible.sync="dialogAudit"
               width="30%">
               <div class="forms">
                   <div class="child">
                       <div class="name"><span>*</span>审核结果：</div>
                       <el-radio-group v-model="sendInfoTwo.checkStatus">
                           <el-radio 
                       	:label="item.value" v-for="(item,index) in statusList" :key="index"
                       	>{{item.name}}</el-radio>
                           <!-- <el-radio :label="2">未通过</el-radio> -->
                       </el-radio-group>
                   </div>
                   <div class="error" v-if="errors['sendInfoTwo.checkStatus']">错误提示：{{errors['sendInfoTwo.checkStatus']}}</div>
                   <div class="childTextarea">
                       <div class="name">说明：</div>
                       <div class="content"><el-input type="textarea" v-model="sendInfoTwo.checkRemark" show-word-limit maxlength="200"></el-input></div>
                   </div>
                   <div class="doubleBtn">
                       <el-button size="small" type="primary" @click="submit">确认</el-button>
                       <el-button size="small" @click="cancel">取消</el-button>
                   </div>
               </div>
           </el-dialog>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    data(){
        return{
          loading:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            },{
                value: '4',
                label: '活动标题'
                }, {
                value: '5',
                label: '申请人姓名'
            }],//检索下拉
            sendInfoOne:{
               time:"",//日期
               drop:'',//检索下拉值
               dropValue:"",//检索输入值
            },//检索提交数据
			statusList:[],//审核状态
			sendInfoTwo:{
			    applyId:'',//审核id
			    checkStatus:'1',//审核结果
			    checkRemark:'',//说明
			},//审核提交数据
            tab:'1',//选项卡
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//审核弹出层
            dialogDetail:false,//表格内详情弹出层
			sendInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				checkStatus:'',//审核状态
				endDate:null,//结束时间
				startDate:null,//开始时间
				id:null,//资讯ID
				status:null,//上架状态
				name:null,//姓名
				userName:null,//账号
				activityTitle:'',//活动标题
				applicant:'',//申请人姓名
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
			dataInfo:'',//详细信息
			dataInfos:'',//活动详情
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.checkStatus':{
            test:function(){
                if(this.sendInfoTwo.checkStatus){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择审核结果'
        },
    },
	created() {
		// getDict('CHECK_STATUS').then(data=>{
		//     this.statusList = data.CHECK_STATUS;
		// })
		this.getReviewResultList()
		// 待审核
		if(this.authorities.indexOf('sys:permission:background:salon:apply:unAudit')==-1){
			this.tab='2'
		}
		// 待审核 和审核记录存在一个
		if(this.authorities.indexOf('sys:permission:background:salon:apply:unAudit')!=-1||this.authorities.indexOf('sys:permission:background:salon:apply:audit')!=-1){
			this.getList()
		}
	},
  mounted(){
    const that  = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90
          that.bHeight = document.body.clientHeight - 55  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90
                  that.bHeight = document.body.clientHeight - 55  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      //获取字典 审核状态
      async getReviewResultList () {
          // const {code,data} = await this.$axiosz.get('backstage/sysDict/isShow/CHECK_STATUS')
          const {code,data} = await this.$axiosz.get('backstage/sysDict/auditOption')
          if (code == 200) {
                  this.statusList = data; 
              }
      },
      onReset(){
        this.sendInfo.currentPage=1;
            this.sendInfo.pageSize=10;
            this.sendInfo.property=void 0;
            this.sendInfo.direction=void 0;
            this.sendInfo.checkStatus= void 0;
            this.sendInfo.endDate=void 0;
            this.sendInfo.startDate=void 0;
            this.sendInfo.id=void 0;
            this.sendInfo.status=void 0;
            this.sendInfo.name=void 0;
            this.sendInfo.userName=void 0;
            this.sendInfo.activityTitle=void 0;
            this.sendInfo.applicant=void 0;
            this.sendInfoOne.time=void 0;
            this.sendInfoOne.drop=void 0;
            this.sendInfoOne.dropValue=void 0;
            if(this.$refs.multipleTable) this.$refs.multipleTable.clearSort()
            if(this.$refs.table) this.$refs.table.clearSort()
            this.getList()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		// 待审核列表
		getList(){
      this.loading = true
			let url='';	
			if(this.tab==='1'){
				url='/backstage/activity/salon/apply/pending/review/list';
			}else{
				url='/backstage/activity/salon/apply/audited/list';
			}
			this.$axiosc.get(url,{params:this.sendInfo}).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        // 切换选项啦
        changeTab:function(tab){
            
            this.tab=tab.name;
		      	this.onReset()
        },
        //检索事件
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0];
				this.sendInfo.endDate=lookData.time[1];
			}else {
                this.sendInfo.startDate=null;
                this.sendInfo.endDate=null;
            }
			// 检索值
			let lookdell=lookData.drop;
			if(lookdell==1){
				this.sendInfo.id=lookData.dropValue;
				this.sendInfo.userName=null;
				this.sendInfo.activityTitle=null;
				this.sendInfo.name=null;
				this.sendInfo.applicant=null;
			}else if(lookdell==2){
				this.sendInfo.userName=lookData.dropValue;
				this.sendInfo.activityTitle=null;
				this.sendInfo.id=null;
				this.sendInfo.name=null;
				this.sendInfo.applicant=null;
			}else if(lookdell==3){
				this.sendInfo.name=lookData.dropValue;
				this.sendInfo.id=null;
				this.sendInfo.userName=null;
				this.sendInfo.activityTitle=null;
				this.sendInfo.applicant=null;
			}else if(lookdell==4){
				this.sendInfo.activityTitle=lookData.dropValue;
				this.sendInfo.id=null;
				this.sendInfo.userName=null;
				this.sendInfo.applicant=null;
				this.sendInfo.name=null;
			}else if(lookdell==5){
				this.sendInfo.applicant=lookData.dropValue;
				this.sendInfo.id=null;
				this.sendInfo.userName=null;
				this.sendInfo.title=null;
				this.sendInfo.name=null;
			}
			this.getList()
		},
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if (order == 'ascending') {
                order = 'ASC';
            } else {
                order = 'DESC';
            }
            this.sendInfo.property = prop;
            this.sendInfo.direction = order;
            this.getList()
        },
        //查看明细
        check:function(row){
            // this.$axiosc.get('/backstage/activity/salon/apply/details/'+row.id).then((r)=>{
            //     if(r.code==200){
            // 		this.dataInfos=r.data;
            // 		this.dialogInfo=true;
            //     }else{
            //         this.$alert(r.msg);
            //     }
            // })
            this.$router.push({path: `/auditsManagement/applicationSalon/detail/${this.tab}`, query: {id: row.id, index: '/auditsManagement/applicationSalon'},param:{type:this.tab}})

        },
		//查看活动明细
		viewDetails:function(row){
		    // this.$axiosc.get('/backstage/activity/salon/details/'+row.loanId).then((r)=>{
		    //     if(r.code==200){
		    // 		this.dataInfo=r.data;
		    // 		this.dialogDetail=true;
		    //     }else{
		    //         this.$alert(r.msg);
		    //     }
		    // })
         this.$router.push({path: `/auditsManagement/applicationSalon/apply/detail/${this.tab}`, query: {id:row.loanId, index: '/auditsManagement/applicationSalon'},param:{type:this.tab}})
		},
        //下载附件
        downLoad:function(url){
			window.open(url)
		},
        //打开审核
        audit:function(row){
            this.sendInfoTwo.applyId=row.id;
            this.dialogAudit=true;
            this.sendInfoTwo.checkRemark='';
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
            	this.$axiosc.put('/backstage/common/applyReview',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
            	    if(res.code==200){
            	        this.$message({
            	            type: 'success',
            	            message: res.msg
            	        });
            			this.dialogAudit=false;
            			this.getList()
            	    }else{
            	        this.$message.warning(res.msg)
            	    }
            	})
            }
        },
		//分页功能模块
		// 下一頁
		nextpage(val) {
		  this.sendInfo.currentPage=val;
		  this.getList()();
		},
		// 上一頁
		previouspage(val) {
		  this.sendInfo.currentPage=val;
		  this.getList();
		},
		handleSizeChange(val) {
		  this.sendInfo.pageSize = val;
		  this.getList()
		},
		handleCurrentChange(val) {
			this.sendInfo.currentPage=val;
		  this.sendInfo.currentPage = val;
		  this.getList()
		},
    },
	watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>

<style lang="scss" scoped>
    .richText{
        img{
            width:100%;
        }
    }
	.basic{
		.content{
			/deep/ p{
				line-height: 20px;
			}
		}
	}
</style>